require([
    "quantitySelector/quantitySelector"
],
function (quantitySelector) {

    quantitySelector.init();
    window.Coria = window.Coria || {};
    window.Coria.reInitQuantitySelectors = quantitySelector.init;
    window.Coria.setQuantity = quantitySelector.setQuantity;
});

define("QuantitySelector/main", function(){});

